import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29553cad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Practical" }
const _hoisted_2 = { class: "Practical-intro-content" }
const _hoisted_3 = { class: "Practical-intro-title h1" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  class: "Practical-discover",
  "data-scroll-section": ""
}
const _hoisted_6 = { class: "Practical-discover-title h1" }
const _hoisted_7 = { class: "Practical-discover-content-left" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "Practical-download-text" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Practical-download-cta-background" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Practical-download-cta-background Practical-download-cta-background--hover" }, null, -1))
const _hoisted_14 = { class: "Practical-download-cta-inner" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    opacity: "0.2",
    cx: "32",
    cy: "32",
    r: "31.5",
    stroke: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M32 22L32 38M32 38L26 31.8704M32 38L38 31.8704",
    stroke: "white",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M40 42L24 42",
    stroke: "white"
  })
], -1))
const _hoisted_16 = { class: "Practical-download-cta-inner Practical-download-cta-inner--hover" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    opacity: "0.2",
    cx: "32",
    cy: "32",
    r: "31.5",
    stroke: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M32 22L32 38M32 38L26 31.8704M32 38L38 31.8704",
    stroke: "white",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M40 42L24 42",
    stroke: "white"
  })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Practical-discover-content-right --img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "Practical-discover-content-img" }, [
    /*#__PURE__*/_createElementVNode("picture", null, [
      /*#__PURE__*/_createElementVNode("source", { srcset: "/dev/practical/bottle.png 1x, /dev/practical/bottle@2x.png 2x" }),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/dev/practical/bottle.png",
        alt: "practical bottle"
      })
    ])
  ])
], -1))
const _hoisted_19 = ["srcset"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Practical-slider-drag" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "21",
    height: "8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M.146 4.036a.5.5 0 0 1 0-.708L3.328.146a.5.5 0 1 1 .708.708L1.707 3.182h17.586L16.965.854a.5.5 0 1 1 .707-.708l3.182 3.182a.5.5 0 0 1 0 .708l-3.182 3.182a.5.5 0 1 1-.707-.708l2.328-2.328H1.707L4.036 6.51a.5.5 0 1 1-.708.708L.146 4.036Z",
      fill: "#fff"
    })
  ])
], -1))
const _hoisted_22 = { class: "Practical-discover-content-left" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "Practical-discover-content-right --text" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "Practical-events-title h1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "21",
  height: "8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M.146 4.036a.5.5 0 0 1 0-.708L3.328.146a.5.5 0 1 1 .708.708L1.707 3.182h17.586L16.965.854a.5.5 0 1 1 .707-.708l3.182 3.182a.5.5 0 0 1 0 .708l-3.182 3.182a.5.5 0 1 1-.707-.708l2.328-2.328H1.707L4.036 6.51a.5.5 0 1 1-.708.708L.146 4.036Z",
    fill: "#000"
  })
], -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_ParallaxObject = _resolveComponent("ParallaxObject")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_CursorFollow = _resolveComponent("CursorFollow")!
  const _component_RoundSection = _resolveComponent("RoundSection")!
  const _component_EventsCalendarItem = _resolveComponent("EventsCalendarItem")!
  const _component_Questions = _resolveComponent("Questions")!
  const _component_LayoutNotConnected = _resolveComponent("LayoutNotConnected")!

  return (_openBlock(), _createBlock(_component_LayoutNotConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createVNode(_component_AppearObject, {
          class: "Practical-intro",
          "data-scroll-section": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ParallaxObject, {
              class: "Practical-intro-inner grid padded",
              ratio: -0.2
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h1", _hoisted_3, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('practical.title1')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createElementVNode("h2", {
                    class: "Practical-intro-subtitle h3",
                    innerHTML: _ctx.$t('practical.description1')
                  }, null, 8, _hoisted_4),
                  _createVNode(_component_ButtonHover, {
                    to: "/login#events",
                    class: "Practical-intro-link button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('practical.registerButton')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["ratio"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_RoundSection, { class: "Practical-discover-inner padded" }, {
            default: _withCtx(() => [
              _createVNode(_component_AppearObject, { class: "grid" }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", _hoisted_6, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('practical.title2')
                    }, null, 8, ["innerHTML"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_AppearObject, { class: "grid Practical-discover-content" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: "Practical-discover-content-text h3",
                      innerHTML: _ctx.$t('practical.description2-1')
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", {
                        innerHTML: _ctx.$t('practical.download-content', { name: _ctx.download.title })
                      }, null, 8, _hoisted_10),
                      _createElementVNode("a", {
                        class: "Practical-download-cta",
                        href: _ctx.download.url,
                        download: "",
                        target: "_blank",
                        rel: "noreferrer"
                      }, [
                        _hoisted_12,
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, [
                          _createTextVNode(_toDisplayString(_ctx.download.title) + " ", 1),
                          _hoisted_15
                        ]),
                        _createElementVNode("span", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_ctx.download.title) + " ", 1),
                          _hoisted_17
                        ])
                      ], 8, _hoisted_11)
                    ])
                  ]),
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_component_CursorFollow, null, {
                cursor: _withCtx(() => [
                  _hoisted_21
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_AppearObject, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Slider, {
                        ref: "slider",
                        wrapAround: false,
                        contain: true,
                        autoPlay: false,
                        class: "Practical-slider"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sliderImages, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "Practical-slider-item"
                            }, [
                              _createElementVNode("picture", {
                                class: "Practical-slider-item-image",
                                style: _normalizeStyle({'--index': i})
                              }, [
                                _createElementVNode("source", {
                                  srcset: `/dev/practical/${item.image}.jpg 1x, /dev/practical/${item.image}@2x.jpg 2x`
                                }, null, 8, _hoisted_19),
                                _createElementVNode("img", {
                                  src: `/dev/practical/${item.image}.jpg`,
                                  alt: item.alt
                                }, null, 8, _hoisted_20)
                              ], 4)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_AppearObject, { class: "grid Practical-discover-content" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", {
                      class: "Practical-discover-content-text h3",
                      innerHTML: _ctx.$t('practical.description2-2')
                    }, null, 8, _hoisted_23)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", {
                      class: "Practical-discover-content-text h3 --delay",
                      innerHTML: _ctx.$t('practical.description2-3')
                    }, null, 8, _hoisted_25)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        (_ctx.events.length > 0)
          ? (_openBlock(), _createBlock(_component_AppearObject, {
              key: 0,
              class: "Practical-events",
              "data-scroll-section": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_RoundSection, { class: "Practical-events-inner padded" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AppearObject, { class: "grid" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_26, [
                          _createVNode(_component_LineByLine, {
                            innerHTML: _ctx.$t('practical.events-title')
                          }, null, 8, ["innerHTML"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_CursorFollow, null, {
                      cursor: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(['Practical-events-slider-drag', {  '--under-2' : _ctx.events.length <= 2, '--under-3' : _ctx.events.length <= 3, '--under-4' : _ctx.events.length <= 4 }])
                        }, _hoisted_28, 2)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_AppearObject, { class: "grid" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Slider, {
                              ref: "slider",
                              wrapAround: false,
                              contain: true,
                              autoPlay: false,
                              class: _normalizeClass(['Practical-events-slider', {'--under-2' : _ctx.events.length <= 2, '--under-3' : _ctx.events.length <= 3, '--under-4' : _ctx.events.length <= 4}])
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (item, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "Practical-events-slider-item"
                                  }, [
                                    _createVNode(_component_EventsCalendarItem, {
                                      place: item.city,
                                      date: item.start_date,
                                      size: "large",
                                      class: "Practical-events-slider-item-date",
                                      style: _normalizeStyle({'--index': i})
                                    }, null, 8, ["place", "date", "style"])
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ButtonHover, {
                      to: "/login#events",
                      class: "Practical-events-link button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('practical.registerButton')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Questions, {
          class: "Practical-questions",
          "background-color": _ctx.events.length <= 0 ? 'redLight' : 'white',
          title: _ctx.$t('practical.questions-title'),
          description: _ctx.$t('practical.questions-description'),
          cta: {to:'/faq', label: _ctx.$t('practical.questions-cta')}
        }, null, 8, ["background-color", "title", "description", "cta"])
      ])
    ]),
    _: 1
  }))
}